import React from 'react';
import Paper from '@material-ui/core/Paper';
import {makeStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import RagnarokHubList from "../context/RagnarokHubList";
import CenterFocusStrongIcon from '@material-ui/icons/CenterFocusStrong';
import CenterFocusWeakIcon from '@material-ui/icons/CenterFocusWeak';
import {useAuth0} from "../auth/sso";
import Loading from "./Loading";
import {useNavBarContext} from "./NavBar";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        overflow: 'hidden',
        padding: theme.spacing(2, 3),
        textAlign: 'center'
    },
    paper: {
        maxWidth: 300,
        margin: `${theme.spacing(1)}px auto`,
        padding: theme.spacing(2),
        cursor: 'pointer',
        textAlign: 'left'
    },
}));

function HubListDetail({hub, selectHub}) {
    const classes = useStyles();

    const {title, launched} = hub;

    return (
        <Paper className={classes.paper} onClick={() => selectHub(hub.id)}>
            <Grid container wrap="nowrap" spacing={2} direction="row">
                <Grid item>
                    {
                        launched
                            ? <CenterFocusStrongIcon style={{color: "green"}}/>
                            : <CenterFocusWeakIcon style={{color: "gray"}}/>
                    }
                </Grid>
                <Grid item>
                    <Typography noWrap>{title}</Typography>
                </Grid>
            </Grid>
        </Paper>
    );
}

function renderContent({hubs, selectHub}) {
    return hubs.map((hub) =>
        <HubListDetail key={`hub_list_${hub.id}`} hub={hub} selectHub={selectHub}/>
    );
}

export default function HubList({selectHub}) {
    const classes = useStyles();

    const {handleTitleUpdate} = useNavBarContext();
    const {loading, user} = useAuth0();

    if (loading || !user) {
        return <Loading/>;
    }

    const {hubs, hubsLoading} = RagnarokHubList();

    handleTitleUpdate("Hubs");

    if (hubsLoading) {
        return <Loading/>;
    }

    return (
        <div className={classes.root}>
            {renderContent({hubs, selectHub})}
        </div>
    );
}